import {
  ClickableSubtitle,
  Contact,
  ContactSubtitle,
} from '@rumblefish/ui/Rumblefish23Theme';
import { contactFormId } from '../const';

const SubtitleComponent = () => (
  <>
    <ContactSubtitle
      variant="regular_500"
      width={{ xs: '100%', md: '55%', xl: '75%' }}>
      Ready to build a serious Web3 product? You'll want a partner who knows
      the ecosystem from the inside. That's Rumble Fish, a two-time Stellar
      Community Fund grantee. Tell us your requirements and we'll help you get
      your Stellar product to market.
    </ContactSubtitle>

    <ContactSubtitle variant="regular_300">
      Fill out the form or schedule an introductory call now:
      <br />
      <ClickableSubtitle
        color="yellow"
        link={'https://bit.ly/rf-sylwia-meeting'}
        target="_blank"
        rel="noopener noreferrer">
        Yes, let's set up a meeting!
      </ClickableSubtitle>
    </ContactSubtitle>
  </>
);

export const ContactStellar = () => {
  return (
    <Contact
      id={contactFormId}
      color="yellow"
      title="Let's build Stellar products together!"
      subtitleComponent={<SubtitleComponent />}
    />
  );
};
